import React, { useMemo } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { TicketIcon } from "@heroicons/react/24/solid";
import { CSVLink } from "react-csv";
import MaterialTableTS from "../../../../components/tables/MaterialTableTS";
import DownloadButton from "../../../../components/DownloadButton";
import useGetAllMappedToCDRC from "./hooks/useGetAllMappedToCDRC";
import { useHistory } from "react-router-dom";
import { mainSelectedTab } from "../../atoms";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { CarrierAgreementMgmtTabs } from "../../carrierAgreementTabs";
import { ICDRCExceptionReport } from "./types";

interface CDRCExceptionReportProps {}
export const CDRCExceptionReport: React.FC<CDRCExceptionReportProps> = () => {
  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const history = useHistory();
  const userPermissions = useRecoilValue(permissionsSelector);

  const { data: mappedToCDRCdata, isLoading: mappedToCDRCdataLoading } =
    useGetAllMappedToCDRC();

  const mappedToCDRCRecords = mappedToCDRCdata?.filter((x) => {
    return x.mappedToCdrc === true;
  });
  function percentage(partialValue, totalValue) {
    return (100 * partialValue) / totalValue;
  }
  //For downloading table data
  const exportdata = useMemo(
    () =>
      mappedToCDRCdata?.map((data: ICDRCExceptionReport) => ({
        CarrierName: data.carrierName,
        ProducerCode: data.producerCode,
        ProducerSubCode: data.producerSubCode,
        LineOfBusiness: data.lineOfBusiness,
        States: data.state,
        OfficeCode: data.officeCode,
        StoreNumber: data.storeNumber,
        "Office Name": data.officeName,
        ProgramName: data.program,
        MGA: data.mga,
        DistributionChannelName: data.distributionChannelName,
        IsActive: data.status,
        MappedToCDRC: data.cdrc,
      })) ?? [],
    [mappedToCDRCdata]
  );

  let dateTimeToday = new Date(new Date().toLocaleString()).toLocaleString();
  const csvReport = {
    filename: "CDRCexceptionReport_" + dateTimeToday + ".csv",
    data: exportdata ? exportdata : [],
  };

  const officeColumns = [
    { title: "CarrierName", field: "carrierName" },
    { title: "ProducerCode", field: "producerCode" },
    { title: "ProducerSubCode", field: "producerSubCode" },
    { title: "LineOfBusiness", field: "lineOfBusiness" },
    { title: "States", field: "state" },
    { title: "OfficeCode", field: "officeCode" },
    { title: "StoreNumber", field: "storeNumber" },
    {
      title: "Office Name",
      field: "officeName",
      render: (rowData) => {
        return (
          <div
            className="cursor-pointer"
            onClick={() => {
              const url = "/officesettings/officesetting";
              history.push({
                pathname: url,
                state: {
                  pathname: url,
                  officeCode: rowData?.officeCode,
                  action: "mappedtocdrcreport",
                },
              });
              window.location.reload();
              let userTabs = [
                {
                  to: "",
                },
              ];
              [...CarrierAgreementMgmtTabs].forEach((tabs) => {
                let temp = [...userPermissions].filter(
                  (user) => user === tabs.permission
                );
                if (temp.length > 0)
                  userTabs.push({
                    to: tabs.to,
                  });
              });
              userTabs.shift();
              const index = userTabs.findIndex((c) => c.to === url);
              setSelectedIndex(index);
            }}
          >
            <span className="text-quinary  font-bold underline text-sm ">
              {rowData.officeName}
            </span>
          </div>
        );
      },
    },
    { title: "ProgramName", field: "program" },
    { title: "MGA", field: "mga" },
    { title: "DistributionChannelName", field: "distributionChannelName" },
    { title: "isActive", field: "status" },
    {
      title: "MappedToCDRC",
      field: "cdrc",
    },
  ];

  return (
    <div className="text-xs items-center">
      <div className="">
        <div className="mx-4 mt-4 overflow-x-auto">
          <div className="flex mb-2 gap-2 items-center">
            <div>
              <TicketIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
            </div>
            <div className="flex flex-col leading-tight">
              <div className="text-gray-500 text-md font-medium">
                Report: Producer Codes
              </div>
              <div className="flex items-center font-bold text-lg text-primary">
                {"CDRC Exception Report"}
              </div>
            </div>
          </div>
          <div className="mt-2" />
          <div className="flex justify-between mb-2 mr-2">
            <div className="flex items-center gap-1">
              <span className="text-gray-500 text-sm">
                Total Mapped Records:{" "}
              </span>
              <span className="text-primary text-base font-semibold">
                {mappedToCDRCdata
                  ? (
                      Math.round(
                        percentage(
                          mappedToCDRCRecords?.length,
                          mappedToCDRCdata.length
                        ) * 100
                      ) / 100
                    ).toFixed(2)
                  : 0}
                %:{" "}
              </span>

              <span className="text-reportsColor text-base font-semibold">
                {mappedToCDRCRecords?.length} out of {mappedToCDRCdata?.length}
              </span>
            </div>
            <CSVLink {...csvReport}>
              <DownloadButton buttonValue="Download File" onClick={() => {}} />
            </CSVLink>
          </div>
        </div>
        <div className="box-shadow mx-4 mb-4 mt-2 overflow-x-auto grid grid-row">
          <MaterialTableTS
            data={mappedToCDRCdata}
            isLoading={mappedToCDRCdataLoading}
            columns={officeColumns}
            showTitle={false}
            toolbarSearch={true}
            showToolbar={true}
          />
        </div>
      </div>
    </div>
  );
};
